import React from 'react';
import { Navigate } from 'react-router-dom';
import jwtUtils from '../utilities/jwtUtils'; // Asegúrate de tener esta utilidad para decodificar el token

const ProtectedRouteAsesor = ({ element }) => {
  const payload = jwtUtils.getValidRefreshTokenPayload();
  if (!payload) {
    return <Navigate to="/401" replace />;
  }

  if (payload.rol !== 'asesor') {
    return <Navigate to="/401" replace />;
  }

  // Si hay token, se muestra el elemento original
  return element;

};

export default ProtectedRouteAsesor;
